export const requestNotificationPermission = async () => {
  if (!("Notification" in window)) {
    console.log("This browser does not support notifications.");
    return;
  }

  let permission = Notification.permission;

  if (permission === "default") {
    permission = await Notification.requestPermission();
  }

  console.log("Notification permission:", permission);
};
export const showSystemNotification = (title: string, body: string) => {
  if (Notification.permission === "granted") {
    new Notification(title, {
      body,
      icon: "/logo.png",  // optional icon
    });
  } else {
    console.warn("Notifications are blocked by the user.");
  }
};
